import React, { useState, useEffect } from 'react';
import { getUnclaimedProfiles, claimProfiles } from '../db';
import { useAuth } from '../context/AuthContext';
import { UserPlus, Check, User } from 'lucide-react';

const ClaimProfile = ({ onComplete }) => {
  const { currentUser } = useAuth();
  const [unclaimed, setUnclaimed] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [claiming, setClaiming] = useState(false);

  useEffect(() => {
    const fetchUnclaimed = async () => {
      try {
        const profiles = await getUnclaimedProfiles();
        setUnclaimed(profiles);
      } catch (err) {
        console.error("Erreur lors de la récupération des profils:", err);
      }
      setLoading(false);
    };
    fetchUnclaimed();
  }, []);

  const toggleSelect = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter(pId => pId !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  const handleClaim = async () => {
    if (!currentUser) return;
    setClaiming(true);
    try {
      if (selected.length > 0) {
        await claimProfiles(selected, currentUser.uid);
      }
      onComplete(); // Tells parent we are done claiming
    } catch (err) {
      console.error(err);
      alert("Erreur lors de la récupération des profils.");
      setClaiming(false);
    }
  };

  if (loading) {
    return <div style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: '2rem' }}>Recherche des profils existants...</div>;
  }

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'var(--bg-color)',
      zIndex: 9998,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{ maxWidth: '600px', width: '100%', textAlign: 'center' }}>
        <h2 style={{ color: 'var(--primary-color)', marginBottom: '0.5rem' }}>Bienvenue !</h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem' }}>
          Sélectionne tes profils existants pour les lier à ton nouveau compte.
        </p>

        {unclaimed.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', justifyContent: 'center', marginBottom: '2rem' }}>
            {unclaimed.map(profile => (
              <div 
                key={profile.id} 
                onClick={() => toggleSelect(profile.id)}
                style={{ 
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem',
                  cursor: 'pointer',
                  opacity: selected.includes(profile.id) ? 1 : 0.6,
                  transform: selected.includes(profile.id) ? 'scale(1.05)' : 'scale(1)',
                  transition: 'all 0.2s'
                }}
              >
                <div style={{ position: 'relative' }}>
                  <div style={{ 
                    width: '80px', height: '80px', borderRadius: '16px', 
                    backgroundColor: profile.color || 'var(--primary-color)', 
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: 'var(--shadow)',
                    overflow: 'hidden',
                    border: selected.includes(profile.id) ? '3px solid var(--primary-color)' : '3px solid transparent'
                  }}>
                    {profile.avatarUrl ? (
                      <img loading="lazy" src={profile.avatarUrl} alt={profile.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <User size={40} color="#fff" />
                    )}
                  </div>
                  {selected.includes(profile.id) && (
                    <div style={{ position: 'absolute', top: '-5px', right: '-5px', backgroundColor: 'var(--primary-color)', color: 'white', borderRadius: '50%', padding: '4px' }}>
                      <Check size={16} />
                    </div>
                  )}
                </div>
                <span style={{ fontWeight: selected.includes(profile.id) ? 'bold' : 'normal' }}>{profile.name}</span>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
            Aucun profil libre trouvé.
          </div>
        )}

        <button 
          className="btn btn-primary" 
          onClick={handleClaim}
          disabled={claiming}
          style={{ width: '100%', maxWidth: '300px', padding: '1rem', fontSize: '1.1rem' }}
        >
          {claiming ? 'Enregistrement...' : (selected.length > 0 ? `Récupérer ${selected.length} profil(s)` : 'Commencer à zéro')}
        </button>
      </div>
    </div>
  );
};

export default ClaimProfile;
